import {MithrilComponent} from '@bitstillery/mithril'
import {notifier} from '@bitstillery/common/app'
import {Icon} from '@bitstillery/common/components'
import m from '@bitstillery/mithril'

interface ClipboardCopyAttrs {
    text: string | null
    label?: string
}

/**
 * A clipboard copy functionality, that copies the provided text to the clipboard of the user.
 *
 */
export class ClipboardCopy extends MithrilComponent<ClipboardCopyAttrs> {
    view(vnode: m.Vnode<ClipboardCopyAttrs>): m.Children {
        const {text} = vnode.attrs
        if (text === null) {
            return null
        }
        return (
            <span
                class='clipboard-copy no-click'
                onclick={() => {
                    navigator.clipboard
                        .writeText(text)
                        .then(() => notifier.notify(`Copied ${vnode.attrs.label || `"${text}"`} to clipboard.`, 'info'))
                        .catch(() => {
                            notifier.notify('Copying failed. Please inform the IT team.', 'danger')
                            console.error('Copying failed')
                        })
                }}
            >
                <Icon name='copy' size='xs' className='ml-05' type='info' />
            </span>
        )
    }
}
